export const GET_LEGAL_ENTITIES = 'GET_LEGAL_ENTITIES';
export const CLEAR_RESULTS = 'CLEAR_RESULTS';